import { Pipe, PipeTransform } from '@angular/core';
import { OrderPeriodType } from '../types/deal.types';
import { IssueOrderPeriod } from '../helpers/issue/order-period';

@Pipe({
  name: 'orderPeriodHoverText',
  standalone: false,
})
export class OrderPeriodHoverPipe implements PipeTransform {
  public transform(
    value: IssueOrderPeriod.OrderPeriodCountdown
  ): string | null {
    switch (!!value && value.type) {
      case OrderPeriodType.retail:
        return 'Retail Only';
      case OrderPeriodType.all:
        if (
          value.orderTypes &&
          value.orderTypes.filter(
            t => t.orderType === 'RTL' && t.priority === 1
          ).length
        ) {
          return 'Retail & Institutional';
        }
        return 'Institutional Only';
      case OrderPeriodType.institutional:
        return 'Institutional Only';
      default:
        return null;
    }
  }
}
